import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="footer-page-container1">
      <h1>About Us</h1>
      <div className="footer-page-content1">
        <p>Welcome to Keshri Tobacco, your premier destination for premium tobacco products.</p>
        
        <h2>Our Story</h2>
        <p>Established in 1927, we have dedicated ourselves to providing the highest quality tobacco products to connoisseurs and enthusiasts. Our journey began with a simple mission: to offer a curated selection of premium tobacco products while providing exceptional customer service.</p>
        
        <h2>Our Commitment</h2>
        <p>We take pride in cultivating our products in-house, ensuring full control over quality from seed to sale. Every item we offer is grown with care, harvested responsibly, and undergoes strict quality checks before reaching our customers. This hands-on approach guarantees freshness, authenticity, and excellence in every product we sell.</p>
        
        <h2>Customer Experience</h2>
        <p>At Keshri Tobacco's, we believe that shopping for tobacco products should be an enjoyable experience. Our user-friendly website is designed to help you find exactly what you're looking for with ease. If you have any questions or need recommendations, our knowledgeable team is always ready to assist you.</p>
        
        <h2>Age Verification</h2>
        <p>We are committed to responsible business practices and strictly adhere to all regulations regarding the sale of tobacco products. We require age verification for all purchases to ensure that our products are only sold to adults of legal age.</p>
        
        <p>Thank you for choosing Keshri Tobacco's. We look forward to serving you and becoming your trusted source for premium tobacco products.</p>
      </div>
    </div>
  );
};

export default AboutUs;